import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  ref,
  onMounted,
  watch
} from 'vue';

// #variables
interface IProps {
  modelValue: number;
  min?: number;
  disabled: boolean;
  disableErrors?: boolean;
  prefix: string;
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'AppBidInput',
  props: {
    modelValue: { default: 0 },
    min: { default: 0 },
    disabled: { type: Boolean, default: false },
    disableErrors: { type: Boolean },
    prefix: { default: '' }
  },
  emits: ['input:modelValue'],
  setup(__props: any, { emit: __emit }) {

const amount = ref(0);

// #data
const config = {
  masked: true,
  prefix: '',
  suffix: '',
  thousands: ',',
  decimal: '.',
  precision: 0,
  disableNegative: true,
  disabled: false,
  min: 0,
  max: null,
  allowBlank: false,
  minimumNumberOfCharacters: 0,
  shouldRound: true,
  focusOnRight: false
};

// #emits
const emit = __emit;

// #types
const props = __props;

onMounted(() => {
  amount.value = props.modelValue;
});

watch(amount, () => {
  emit('input:modelValue', amount.value);
});

return (_ctx: any,_cache: any) => {
  const _component_money3 = _resolveComponent("money3")!

  return (_openBlock(), _createBlock(_component_money3, _mergeProps({
    modelValue: amount.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((amount).value = $event)),
    modelModifiers: { number: true }
  }, config, {
    disabled: __props.disabled,
    class: "app-bid-input"
  }), null, 16, ["modelValue", "disabled"]))
}
}

})